import { type RPPDomain } from '@retailer-platform/dashboard/core'

import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'insights-portal-lib',
  totem: {
    tool: 'insights-portal-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    // Uncomment to lazy load your domain's foreign dictionaries
    // ES_ES: () => import('./translations/es-ES.json'),
    // FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {},
  navigationEntries: [],
  adminNavigationEntries: [],
  // NOTE TO DEV: run `pnpm ipp domain register <your-system-name>` to register your domain with Totem here
}

export default definition
